export default __webpack_public_path__ + "static/media/IMG_20220514_121523.2999a8a1.jpg";